module.exports = "https://cb-static.prod-my.games/promo/twitchdrops/img/steam-round.9236eab0.svg";